import React, { useState, useEffect } from 'react';
import Loader from './Loader';
import Viewer from '../components/Viewer/Viever'

const Home = () => {
  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    const fetchData = async () => {
      await new Promise((resolve) => setTimeout(resolve, 4000));
      setIsLoading(false);
    };
    fetchData();
  }, []);

  return (
    <div>
      {isLoading
        ? (
          <div className='bg-slate-200 min-h-screen flex items-center justify-center'>
            <Loader />
          </div>
          )
        : (
          <div>
            <Viewer/>
          </div>
          )}
    </div>
  );
};

export default Home;
